var map = {
	"./Alexander-Nevsky-Cathedral-Sofia.jpg": "c41c",
	"./CentralMineralBath-Sofia-8a_3.jpg": "d09a",
	"./Church-of-St-George-Sofia.jpg": "5b21",
	"./NDK.jpg": "236c",
	"./National-Assembly-Bulgaria.jpg": "34e7",
	"./National-Museum-of-History.jpg": "ddde",
	"./Russian-Church-Sofia.jpg": "532b",
	"./Vitoshka.jpg": "24ae",
	"./ivan-vazov-national-theater.jpg": "c363",
	"./na.png": "c917",
	"./serdika-ruins.jpg": "73ab"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "44b6";